import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import EstimateForm from './estimate/ReactEstimateForm';
import AdminDashboard from './admin/AdminDashboard';
import { BoardList, BoardDetail, BoardWrite } from './board';
import { ErrorBoardList, ErrorBoardDetail, ErrorBoardWrite } from './error-board';
import { ProposalBoardList, ProposalBoardDetail, ProposalBoardWrite } from './proposal-board';

const CRM_WEB_URL = process.env.REACT_APP_CRM_WEB_URL || 'https://crm.cahwindow.co.kr';

function TokenHandler() {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const token = params.get('token');

		if (token) {
			console.log('TokenHandler > Token received from cheongahm-crm-web');

			localStorage.setItem('accessToken', token);

			try {
				const parts = token.split('.');
				if (parts.length === 3) {
					const payload = JSON.parse(atob(parts[1]));

					const userId = payload.sub;
					const username = payload.username || payload.sub;
					const features = payload.features || [];
					const roleId = payload.roleId || null;

					localStorage.setItem('userId', userId);
					localStorage.setItem('username', username);
					localStorage.setItem('features', JSON.stringify(features));
					if (roleId) {
						localStorage.setItem('roleId', String(roleId));
					}

					console.log('TokenHandler > JWT decoded and stored', {
						userId,
						username,
						featuresCount: features.length,
						roleId,
					});
				}
			} catch (error) {
				console.error('TokenHandler > Failed to decode JWT', error);
			}

			const url = new URL(window.location.href);
			url.searchParams.delete('token');

			// 고객 정보 파라미터 유지 (CRM에서 전달된 값)
			const customerParams = new URLSearchParams();
			['customerName', 'customerPhone', 'customerAddress', 'customerAddressDetail', 'estimateNumber'].forEach(key => {
				const value = url.searchParams.get(key);
				if (value) customerParams.set(key, value);
			});
			const queryString = customerParams.toString();

			navigate(`/estimateForm${queryString ? `?${queryString}` : ''}`, { replace: true });
		}
	}, [location, navigate]);

	return null;
}

function RedirectToAuth() {
	useEffect(() => {
		const returnUrl = encodeURIComponent(window.location.origin + '/estimateForm');
		window.location.href = `${CRM_WEB_URL}/login?returnUrl=${returnUrl}`;
	}, []);

	return (
		<div style={{ textAlign: 'center', marginTop: '100px' }}>
			<p>로그인으로 이동 중</p>
		</div>
	);
}

function App() {
	return (
		<BrowserRouter>
			<TokenHandler />
			<Routes>
				<Route path="/" element={<RedirectToAuth />} />

				<Route path="/estimateForm" element={<EstimateForm />} />
				<Route path="/admin" element={<AdminDashboard />} />

				<Route path="/board" element={<BoardList />} />
				<Route path="/board/:id" element={<BoardDetail />} />
				<Route path="/board/write" element={<BoardWrite />} />

				<Route path="/error-board" element={<ErrorBoardList />} />
				<Route path="/error-board/:id" element={<ErrorBoardDetail />} />
				<Route path="/error-board/write" element={<ErrorBoardWrite />} />

				<Route path="/proposal-board" element={<ProposalBoardList />} />
				<Route path="/proposal-board/:id" element={<ProposalBoardDetail />} />
				<Route path="/proposal-board/write" element={<ProposalBoardWrite />} />

				<Route path="/login" element={<RedirectToAuth />} />
				<Route path="/signup" element={<RedirectToSignup />} />
				{/* <Route path="/admin-login" element={<RedirectToAdminLogin />} /> */}
			</Routes>
		</BrowserRouter>
	);
}

function RedirectToSignup() {
	useEffect(() => {
		window.location.href = `${CRM_WEB_URL}/register`;
	}, []);

	return (
		<div style={{ textAlign: 'center', marginTop: '100px' }}>
			<p>회원가입으로 이동 중</p>
		</div>
	);
}

function RedirectToAdminLogin() {
	useEffect(() => {
		const returnUrl = encodeURIComponent(window.location.origin + '/admin');
		window.location.href = `${CRM_WEB_URL}/login?returnUrl=${returnUrl}`;
	}, []);

	return (
		<div style={{ textAlign: 'center', marginTop: '100px' }}>
			<p>관리자 로그인으로 이동 중</p>
		</div>
	);
}

export default App;
